import * as yup from "yup";
import { InferType } from "yup";

// Define the security type mixed
const SecurityTypeEnum = [
  "Equity",
  "CCPS",
  "CCD",
  "OCD",
  "Note",
  "Warrant",
  "RPS",
  "NCD",
  "OCPS",
  "OCRPS",
  "Options",
] as const;

// Define the shareholder type mixed
const ShareholderTypeEnum = [
  "Founder",
  "Angel",
  "VC",
  "Trust",
  "Options",
  "Corporate",
  "Incubators",
  "Accelerator",
  "Angel Network",
  "Others",
  "Angel Fund",
  "Family Office",
  "PE",
  "Financial Institution",
] as const;

// Define the non-priced mixed
const NonPricedEnum = ["Yes", "No"] as const;

// Define the captable company schema
const captableCompanySchema = yup.object({
  companyName: yup.string().required().label("Name of the company"),

  cin: yup
    .string()
    .required()
    .label("Corporate Identity Number of the company"),

  jurisdiction: yup
    .string()
    .required()
    .label("Jurisdiction where the company is registered"),

  valuation: yup.number().required().label("Current valuation of the company"),

  sharePricePerShare: yup.number().required().label("Current price per share"),

  lastRoundName: yup.string().label("Last Round Name"),

  lastRoundSize: yup
    .number()
    .required()
    .label("Size of the last funding round"),

  lastRoundDate: yup
    .string()
    .required()
    .label("Date of the last funding round"),

  captableDate: yup.string().label("Date when the captable was last updated"),

  totalFDBShares: yup
    .number()
    .required()
    .label(
      "Total Fully Diluted Basis (FDB) shares according to MGT-7/latest PAS-3",
    ),
  companyCurrency: yup
    .string()
    .required()
    .label("Currency in which the company's financials are denominated"),
  remarks: yup.string().optional().label("Additional notes or comments"),
});

// Define the shareholder schema
const shareholderSchema = yup.object({
  shareholderName: yup.string().label("Name of the shareholder"),

  securityType: yup
    .mixed<keyof typeof SecurityTypeEnum>()
    .label(
      "Type of security held by the shareholder, such as Equity, CCPS, CCD, etc.",
    ),

  securityClass: yup.string().label("Class or category of the security"),

  nonPriced: yup
    .mixed<keyof typeof NonPricedEnum>()
    .label("Indicates whether the security is non-priced (Yes) or priced (No)"),

  numberOfShares: yup
    .number()
    .label("The total number of shares held by the shareholder"),

  shareholderFDBPercentage: yup
    .number()
    .label(
      "The percentage of fully diluted basis (FDB) shares owned by the shareholder",
    ),

  shareholderType: yup
    .mixed<keyof typeof ShareholderTypeEnum>()
    .label("Category of the shareholder, such as Founders, Angels, VC, etc."),

  shareholderCountry: yup
    .string()
    .label("Country where the shareholder is based or registered"),

  dateOfInvestment: yup
    .string()
    .label("Date when the investment was made by the shareholder"),

  pricePerShare: yup.number().label("Price paid per share during investment"),

  remarks: yup
    .string()
    .optional()
    .label(
      "Additional notes or comments about the shareholder or their investment",
    ),
});

export type Shareholder = InferType<typeof shareholderSchema>;
export type CaptableCompany = InferType<typeof captableCompanySchema>;
export { shareholderSchema, captableCompanySchema };
